/**
 * Hospital Page
 *
 * 医療機関 - マスタメンテナンス
 * Display and manage medical institution (hospital) information.
 */

import React from 'react';
import { CollapsibleCard } from '@/components/molecules';
import HospitalMasterListPanel from './HospitalMasterListPanel';

/**
 * Main Hospital Page Component
 */
const HospitalPage: React.FC = () => {
  return (
    <div className="space-y-4">
      <CollapsibleCard title="医療機関一覧">
        <div className="relative">
          <HospitalMasterListPanel variant="page" />
        </div>
      </CollapsibleCard>
    </div>
  );
};

export default HospitalPage;
